import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString, bbIsObject,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {Button, } from "@material-ui/core";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";
import BBIconRadarSweepWithTargets from "../../../assets/bbCustomIcons/BBIconRadarSweepWithTargets";
import NewBRProvidingElementDialog from "./NewBRProvidingElementDialog";
import NewBRSubdomainProvidedForm from "./NewBRSubdomainProvidedForm";
import BBIconArchive from "../../../assets/bbCustomIcons/BBIconArchive";
import {updateBRSubdomainProvided} from "../../../actions";
import BBIconCheckboxCheckedYes from "../../../assets/bbCustomIcons/BBIconCheckboxCheckedYes";

const TableContainer = ({
    showProvidedOnly = true,
    portfolioView=false,
                        }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    // console.log("myEntity data", myEntity);

    //Get the subdomains that are already in the provided part of the state
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    // console.log("myEntity in BrSubdomainsprovidingtable", myEntity);
    const providedSubdomains = myEntity ? myEntity.subdomains_provided : null;

    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    //Get the subdomains from the techdata if it exists
    //TODO: Fetch the techdata if not present and appropriate to do so

    const techData = myEntity
    && lastCycle
        ? lastCycle.techData
        : null;
    // console.log("techData from lastCycle", lastCycle, techData);
    
    const techSubdomains = techData
    && techData.totals
        ? techData.totals.subdomains
        : null;

    //combine the two domain sets
    const providedAndTechSubdomains = showProvidedOnly
        ? {
            ...providedSubdomains,
        }
        : {
        ...providedSubdomains,
        ...techSubdomains
        }

    const totalNumItems = providedAndTechSubdomains ? Object.keys(providedAndTechSubdomains).length : null

    // console.log("techSubdomains is",techSubdomains, "providedSubdomains is",providedSubdomains,  "providedAndTechSubdomains is",providedAndTechSubdomains);



  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStepBRReportVectorsTable"}>
        {showProvidedOnly ? "Subdomains Added By You" : "Subdomains Detected & Provided"} <Tooltip title={"Subdomains you've provided help increase the fidelity of your score. "}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const handleClickActivation = (data) => {
        // console.log("dispatching handleClickDelete with data of", data, customerIdToUse);
        dispatch(updateBRSubdomainProvided({
            entityId: entityInView,
            customerId: customerIdToUse,
            subdomainId: data.subdomainId,
            newIsActiveStatus: data.newIsActiveStatus,
        }));
    }

  const userTableHeadings = [
      // { field: 'id', headerName: 'ID (full)', hide: true, flex : 2, sortable: true, type: 'string', renderCell: (params) => {
      //
      //         return params.value}},
      { field: 'name', headerName: 'Subdomain', hide: false, sortable: true, type: 'string', flex : 1, cellClassName: "addedSubdomainsNameCol",
          renderHeader: (params) =>
              <span id={"addedSubdomainsHeader"}>Domain</span>, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'addedDatetime', headerName: 'Date Added', hide: false, sortable: true, type: 'dateTime', flex : 0.5, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={`If your company provided this element, this is the date it was provided.`}>
                          <span>
                              {params.value
                                  ? <span>
                                      {bbFormattedDateString(params.value, "short")}
                                  </span>
                                  : "N/A"}

                          </span>
                  </Tooltip>

              ))},
      { field: 'isProvided', headerName: 'Provided',
          // renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={"Provided"}>
          //     <span>Provided</span>
          // </Tooltip></div>,
          hide: false, sortable: true, type: 'boolean', width: 120, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`You or someone from your company provided this element.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This element was not provided by your company, it was discovered by BreachBits.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},
      { field: 'isActive', headerName: 'Active',
          renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={"Active"}>
              <span><BBIconCheckboxCheckedYes/></span>
          </Tooltip></div>, hide: false, sortable: true, type: 'boolean', width: 61, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`This element appeared to be active during our last observation.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This element did not appear to be active during our last observation.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},

      { field: 'isDiscovered', headerName: 'Discovered',
          renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={"Discovered"}>
              <span><BBIconRadarSweepWithTargets/></span>
          </Tooltip></div>, hide: false, sortable: true, type: 'boolean', width: 61, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`We detected this element.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This element was not detected by our most recent discovery methods.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},


      { field: 'actions', headerName: 'Actions', hide: false, width : 90, sortable: false, type: 'string', disableExport: true,
          renderCell: (params) => {

              return <>
                  {params.row.isActive
                      ? <div style={{marginRight:2}}>
                          <Tooltip title={"Archive & remove this subdomain if you believe it is not a part of your IT infrastructure. You can add it back later."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  // size={"small"}
                                  color="default"
                                  // className={}
                                  // onClick={}
                                  // disabled={}
                                  // className={!isTimelineButtonDisabled ? "text-electric-blue" : ""}
                                  onClick={() => handleClickActivation({subdomainId: params.row.id, newIsActiveStatus: false})}
                                  // disabled={isTimelineButtonDisabled}
                              >
                              <BBIconArchive />
                          </Button>
                          </span>

                          </Tooltip>
                      </div>
                      : <div style={{marginRight:2}}>
                          <Tooltip title={"Reactivate this subdomain if you believe it is a part of your IT infrastructure."}>
                          <span>
                              <Button
                                  variant="outlined"
                                  // size={"small"}
                                  color="default"
                                  // className={}
                                  // onClick={}
                                  // disabled={}
                                  className={"text-electric-blue"}
                                  onClick={() => handleClickActivation({subdomainId: params.row.id, newIsActiveStatus: true})}
                                  // disabled={isTimelineButtonDisabled}
                              >
                              <BBIconAdd />
                          </Button>
                          </span>

                          </Tooltip>
                      </div>
                  }


              </>
          }

      },



  ];

    //peel the state data into a form the dataTable can read
  const tableData = providedAndTechSubdomains ? mapObject(providedAndTechSubdomains, (key, subdomain) => {

      return (
        {
            customerId: customer.CustomerId,
            id: key,
            idShort: key.slice(0, 6),
            name: subdomain.subdomain,
            isActive: subdomain.is_active,
            crawls:  subdomain.crawls ? Object.keys(subdomain.crawls).length : 0, //an object of stuff prob just do a count for now
            domainId: subdomain.domain,
            isProvided: subdomain.provided || subdomain.provided_datetime,
            isDiscovered: subdomain.discovered,
            cycleId: subdomain.cycle,
            addedDatetime: subdomain.provided_datetime ? bbDangerousStringToDate(subdomain.provided_datetime) : null,

        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            if(tableData[ob].isActive) {
                arr.push(tableData[ob]);
            }
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    return (
        <div >
            {(((providedAndTechSubdomains && bbIsObject(providedAndTechSubdomains)) || totalNumItems === 0)) ?
            <BBDataTable
                columns={userTableHeadings}
                rows={tableDataAsArray()}
                totalRows={tableDataAsArray().length}
                progressValue={providedAndTechSubdomains
                    ? totalNumItems === 0
                        ? 100
                        : Object.keys(providedAndTechSubdomains).length / totalNumItems * 100
                    : 0}
                // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                title={title}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                // requiresBRLevel = {"infoLevel3"}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                topRightElement={
                    <NewBRProvidingElementDialog
                        disabled={portfolioView ? !isAdministratorForThisEntity : false}
                        formComponent={<NewBRSubdomainProvidedForm targetEntityId={entityInView}/>}
                        buttonLabel={"Subdomain"}
                    />
                }

                defaultSortModel = {[
                    {
                        field: 'isProvided',
                        sort: 'asc',
                    },
                    {
                        field: 'name',
                        sort: 'asc',
                    },

                ]}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!isTrustedAgentForThisEntity}
                portfolioStarter={!isTrustedAgentForThisEntity}
            />
            :
            <BBDataTable
                columns={userTableHeadings}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!isTrustedAgentForThisEntity}
                portfolioStarter={!isTrustedAgentForThisEntity}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer